import { useState, useEffect, useContext } from 'react';
import { Language } from '../../../App';

const useWebinarButtonText = (value, user_id) => {
    const {lang} = useContext(Language)
  const [buttonText, setButtonText] = useState('');
   
  useEffect(() => {
    const userIsHost =
      (value?.user?.id && user_id && String(value.user.id) === String(user_id)) ||
      (value?.user_id && user_id && String(value.user_id) === String(user_id)) ||
      Boolean(value?.is_creator || value?.isCreator || value?.is_owner);

    const rawStatus = value?.status;
    const isLive =
      rawStatus === 1 ||
      rawStatus === "1" ||
      rawStatus === "started" ||
      rawStatus === "live" ||
      rawStatus === "in_progress" ||
      Boolean(value?.is_live || value?.isLive);

    const isEnded =
      rawStatus === 2 ||
      rawStatus === "2" ||
      rawStatus === "ended" ||
      rawStatus === "completed";

    const isReserve = Boolean(
      value?.isReserve ||
      value?.is_reserved ||
      value?.isJoined ||
      value?.is_joined
    );

    if (userIsHost) {
      if (isEnded) {
        setButtonText(lang?.webinar_ended || "Webinar Ended");
      } else if (isLive) {
        setButtonText(lang?.start_webinar || lang?.join_as_host || "Start Webinar");
      } else {
        setButtonText(lang?.not_start_yet || "Not started yet");
      }
    } else {
      if (isEnded) {
        setButtonText(lang?.webinar_ended || "Webinar Ended");
      } else if (isLive) {
        setButtonText(lang?.join_webinar || lang?.join_live_webinar || "Join Webinar");
      } else {
        setButtonText(isReserve ? (lang?.unreserve || "Unreserve") : (lang?.reserve_seat || "Reserve Seat"));
      }
    }
  }, [value, user_id, lang]);

  return buttonText;
};

export default useWebinarButtonText;
